import { permissionOptions } from './Enums';

const getPermissionId = (label) => permissionOptions.find((permission) => permission.label === label)?.id;
const normalizePermissionIds = (permissions = []) =>
  Array.isArray(permissions) ? permissions.map(Number).filter(Number.isFinite) : [];

export const getStoredPermissions = () => {
  try {
    const storedPermissions = JSON.parse(localStorage.getItem('permissions') || '[]');
    return normalizePermissionIds(storedPermissions);
  } catch (error) {
    console.error('Error reading stored permissions:', error);
    return [];
  }
};

export const getDashboardReportAccess = (permissions = getStoredPermissions()) => {
  const normalizedPermissions = normalizePermissionIds(permissions);
  return {
    sales: normalizedPermissions.includes(getPermissionId('VIEW_SALES_REPORTS')),
    branch: normalizedPermissions.includes(getPermissionId('VIEW_BRANCH_REPORTS')),
    inventory: normalizedPermissions.includes(getPermissionId('VIEW_INVENTORY_REPORTS')),
    clients: normalizedPermissions.includes(getPermissionId('VIEW_CLIENTS_REPORTS')),
    discounts: normalizedPermissions.includes(getPermissionId('VIEW_DISCOUNTS_REPORTS')),
    cost: normalizedPermissions.includes(getPermissionId('VIEW_COST_REPORTS')),
  };
};

export const getDashboardEnabledCategories = (permissions = getStoredPermissions()) => {
  const access = getDashboardReportAccess(permissions);
  return ['sales', 'branch', 'inventory'].filter((category) => access[category]);
};

export const hasStoredPermission = (label, permissions = getStoredPermissions()) => {
  const permissionId = getPermissionId(label);
  return permissionId !== undefined && normalizePermissionIds(permissions).includes(permissionId);
};
